import React from 'react';
import { getIn } from 'mori';
import Wahanda from 'common/wahanda';
import ReactDialog from 'src/components/common/react-dialog';
import OverviewView from 'src/components/reports/transactions/common/transaction-summary/overview';
import SummaryRowsView from 'src/components/reports/transactions/common/transaction-summary/row';
import { DialogFooter } from 'components/common/DialogFooter';
import { Button } from 'components/common/Button';

const DIALOG_WIDTH = 470;

interface TipSummaryDialogProps {
  data: {} | null;
  onClose: () => void;
  onReceiptCopy: () => void;
}

export class TipSummaryDialog extends React.Component<TipSummaryDialogProps, {}> {
  renderContent() {
    const { data, onReceiptCopy } = this.props;
    const lang = Wahanda.lang.reports.transactions.checkoutSummary;

    if (!data) {
      return <div className="loading">{lang.loading}</div>;
    }

    const tipAmount = getIn(data, ['checkoutTotals', 'totalTerminalTipAmount']);
    const hasReceipt = Boolean(getIn(data, ['checkoutInformation', 'receiptUri']));

    return (
      <div>
        <OverviewView data={data} lang={lang} />

        <div className="service-section">
          <SummaryRowsView name={lang.tip} totalPrice={tipAmount} />
        </div>

        <div className="transaction-dialog-pricing-section">
          <SummaryRowsView name={lang.totalPrice} totalPrice={tipAmount} additionalClass="total" />
          <SummaryRowsView name={lang.paymentTerminal} totalPrice={tipAmount} />
        </div>

        {hasReceipt && (
          <div className="footer">
            <DialogFooter fullWidth>
              <div className="button-wrapper">
                <Button
                  dataTest="tip-summary-receipt-copy"
                  variant="hollow"
                  colour="help"
                  label={Wahanda.lang.pos.receiptCopyDialog.cta}
                  onClick={onReceiptCopy}
                />
              </div>
            </DialogFooter>
          </div>
        )}
      </div>
    );
  }

  render() {
    const lang = Wahanda.lang.reports.transactions.checkoutSummary;
    return (
      <ReactDialog
        dataTest="report-tip-summary-modal"
        title={lang.dialogTitle}
        classes={{ 'checkout-summary': true }}
        width={DIALOG_WIDTH}
        onClose={this.props.onClose}
      >
        {this.renderContent()}
      </ReactDialog>
    );
  }
}
